import React from "react";

import { useFilter } from "../context/FilterProjectsContext";
import Overview from "./Projects/Overview";
import MertGPT from "./Projects/MertGPT";
import AutoSEO from "./Projects/AutoSEO";
import MertShop from "./Projects/MertShop";
import PixelPals from "./Projects/PixelPals";
import TalksAI from "./Projects/TalksAI";
import EventInv from "./Projects/EventInv";
import InteractiveMap from "./Projects/InteractiveMap";
import MertCloud from "./Projects/MertCloud";
import KioskQuiz from "./Projects/KioskQuiz";

const ProjectsPanel = () => {
  const { selectedFilter } = useFilter();

  const fileInfo = () => {
    if (selectedFilter === "overview") {
      return <Overview />;
    } else if (selectedFilter === "mertgpt") {
      return <MertGPT />;
    } else if (selectedFilter === "autoseo") {
      return <AutoSEO />;
    } else if (selectedFilter === "mertshop") {
      return <MertShop />;
    } else if (selectedFilter === "talksai") {
      return <TalksAI />;
    } else if (selectedFilter === "pixelpals") {
      return <PixelPals />;
    } else if (selectedFilter === "eventinv") {
      return <EventInv />;
    } else if (selectedFilter === "livemap") {
      return <InteractiveMap />;
    } else if (selectedFilter === "mertcloud") {
      return <MertCloud />;
    } else if (selectedFilter === "kioskquiz") {
      return <KioskQuiz />;
    }
  };

  return (
    <div
      className={
        selectedFilter === "overview" ? "panel" : "projects-panel panel"
      }
    >
      {fileInfo()}
    </div>
  );
};

export default ProjectsPanel;
